import React from 'react';
import { motion } from 'framer-motion';
interface EquipmentCardProps {
  name: string;
  image: string;
  status: 'available' | 'in-use';
  index: number;
}
export function EquipmentCard({
  name,
  image,
  status,
  index
}: EquipmentCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.05
  }} whileHover={{
    y: -5
  }} className="bg-white rounded-lg shadow-lg overflow-hidden group" data-id="element-200">
      <div className="relative h-48 overflow-hidden" data-id="element-201">
        <img src={image} alt={name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-202" />
        <div className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-semibold ${status === 'available' ? 'bg-green-500' : 'bg-yellow-500'} text-white`} data-id="element-203">
          {status === 'available' ? 'Available' : 'In Use'}
        </div>
      </div>
      <div className="p-4" data-id="element-204">
        <h3 className="font-bold text-charcoal group-hover:text-gold transition-colors" data-id="element-205">
          {name}
        </h3>
      </div>
    </motion.div>;
}